/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';
import Media from 'react-media';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import Imgix from 'js/components/Imgix';

import { Grid, Typography, breakpoints, withTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import Container from 'bundles/xddp/components/shared/Container';
import type { DLPBannerProps, UserAgentProps } from 'bundles/xddp/types';

import 'css!bundles/xddp/components/__styles__/landing/DLPBanner';

type Props = DLPBannerProps &
  UserAgentProps & {
    theme: Theme;
  };

const styles: Record<string, Interpolation<Theme>> = {
  pageTitle: css`
    font-size: 3rem;
    line-height: 3.75rem;
  `,
};
class DLPBanner extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof DLPBanner.contextTypes>;

  getBackgroundGradient = () => {
    const { primaryColor, secondaryColor } = this.props;

    return `linear-gradient(324.97deg, ${primaryColor} 0%, ${secondaryColor} 100%)`;
  };

  renderHeaderContent = () => {
    const { title, partnerLogo } = this.props;

    return (
      <Container className="content-container">
        <Grid container>
          <Grid item lg={7} md={6} sm={12}>
            <Imgix className="partner-logo" alt={partnerLogo ?? ''} src={partnerLogo ?? ''} />
            <Typography variant="h1semibold" color="invertBody" css={styles.pageTitle}>
              {title}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    );
  };

  renderHeaderContainerDesktop = () => {
    const { bannerImage } = this.props;

    return (
      <div className="header-container">
        <div className="gradient-background" style={{ background: this.getBackgroundGradient() }} />
        {bannerImage && <div className="background-image" style={{ background: `url('${bannerImage}')` }} />}
        {this.renderHeaderContent()}
      </div>
    );
  };

  renderHeaderContainerMobile = () => {
    return (
      <div className="header-container header-container-mobile">
        <div
          className="gradient-background gradient-background-mobile"
          style={{ background: this.getBackgroundGradient() }}
        />
        {this.renderHeaderContent()}
      </div>
    );
  };

  render() {
    const { userAgent } = this.props;
    return (
      <div className="rc-DLPBanner">
        <Media query={{ minWidth: breakpoints.values.md }} defaultMatches={userAgent?.isMobileBrowser}>
          {(matches) => (matches ? this.renderHeaderContainerDesktop() : this.renderHeaderContainerMobile())}
        </Media>
      </div>
    );
  }
}

export default withTheme(DLPBanner);
